import Main from 'components/Resources/Main/Main';

const Resources = () => {

  return (
    <Main/>
  );
};

export default Resources;